module.exports = __webpack_public_path__ + "img/SDG-05-EN-INVERTED.bd329763.png";